import { render } from "./MessagesCreate.vue?vue&type=template&id=c1e8a548&scoped=true"
import script from "./MessagesCreate.vue?vue&type=script&lang=js"
export * from "./MessagesCreate.vue?vue&type=script&lang=js"

import "./MessagesCreate.vue?vue&type=style&index=0&id=c1e8a548&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1e8a548"]])

export default __exports__